import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate } from "@tanstack/react-router";
import { service, useAuthConfig } from "@theprelude/core";
import {
  notifySuccess,
  notifyError,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
} from "@theprelude/ds";

export function AcceptTermsModal({
  areTermsAccepted,
}: {
  areTermsAccepted: boolean;
}) {
  const authConfig = useAuthConfig();
  const navigate = useNavigate();

  const acceptTerms = useMutation({
    mutationFn: async () => {
      return await service(authConfig).iam.acceptTerms("threat_intel", "1");
    },
    onSuccess: () => {
      notifySuccess({
        message:
          "Successfully agreed to terms and conditions, threat intel access has been granted",
      });
    },
    onError: async (error) => {
      notifyError({
        message: "Error occurred while trying accept terms and conditions",
        error,
        dismissible: true,
      });
    },
  });

  return (
    <Dialog
      open={!areTermsAccepted}
      onOpenChange={(value) => {
        if (!value) {
          void navigate({
            to: "/threat-intel/import/feed",
            params: (prev) => prev,
          });
        }
      }}
    >
      <DialogContent hideClose disableImplicitClose>
        <div className="flex flex-col gap-8 pb-4 text-base">
          <span>
            AI-generated tests and detections may be inaccurate or misleading.
            Please review and test the source code on non-production machines
            prior to deployment.
          </span>
          <a
            href="https://www.preludesecurity.com/legal/ai-user-guidelines"
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer underline underline-offset-2"
          >
            Prelude&apos;s Detect AI User Guidelines
          </a>
        </div>

        <DialogFooter>
          <Link to="/home" params={(prev) => prev}>
            <Button intent="secondary">Cancel</Button>
          </Link>
          <Button
            intent="primary"
            loading={acceptTerms.isPending}
            onClick={() => acceptTerms.mutate()}
          >
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
